import { Icon } from '@kanda-libs/ks-design-library';
import OpenBankingInfo from './OpenBankingInfo';
import useInfoPopoverDesktop from './useInfoPopoverDesktop';

const OpenBankingDesktop: React.FunctionComponent = function () {
  const { elementRef, visible } = useInfoPopoverDesktop();

  return (
    <div ref={elementRef} className="z-50 mb-px relative">
      <Icon
        icon="info"
        className="w-4 cursor-pointer min-w-4 text-neutral-500 ml-2"
        size={16}
        stroke="neutral-600"
      />
      {visible && <OpenBankingInfo />}
    </div>
  );
};

export default OpenBankingDesktop;
